// extracted by mini-css-extract-plugin
export var body = "_hj-0";
export var sectionHeader = "_hj-4";
export var shortcutColumns = "_hj-2";
export var shortcutList = "_hj-1";
export var shortcutSection = "_hj-3";